import React, { useState } from 'react';
import { Check } from 'lucide-react';

export interface BaseInteractiveProps {
  exercise: any;
  onAnswer: (answer: any) => void;
  showFeedback?: boolean;
  disabled?: boolean;
}

// Text Input Component
export const TextInputComponent: React.FC<BaseInteractiveProps> = ({
  exercise,
  onAnswer,
  showFeedback = false,
  disabled = false
}) => {
  const [textAnswer, setTextAnswer] = useState('');
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSubmit = () => {
    if (disabled || !textAnswer.trim()) return;
    setHasSubmitted(true);
    onAnswer(textAnswer.trim());
  };

  return (
    <div className="space-y-4">
      <div className="mb-4">
        <p className="text-gray-700 mb-3">{exercise.content}</p>
        <p className="font-medium text-gray-900 mb-3">{exercise.question}</p>
      </div>

      <div className="space-y-3">
        <textarea
          value={textAnswer}
          onChange={(e) => setTextAnswer(e.target.value)}
          disabled={disabled || hasSubmitted}
          placeholder={exercise.placeholder || "Type your answer here..."}
          rows={exercise.rows || 4}
          maxLength={exercise.maxLength}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />

        {!hasSubmitted && (
          <button
            onClick={handleSubmit}
            disabled={disabled || !textAnswer.trim()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Submit Answer
          </button>
        )}
      </div>

      {showFeedback && hasSubmitted && exercise.explanation && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Check className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-blue-800 mb-1">Sample Response:</p>
              <p className="text-sm text-blue-700">{exercise.explanation}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};